export enum ImageConvertStatus {
  PENDING = 'PENDING',
  INCORRECT_PAGES = 'INCORRECT_PAGES',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
  UNCONVERTABLE_EXTENSION = 'UNCONVERTABLE_EXTENSION',
}

export function isImageConvertStatusSuccess(
  status: ImageConvertStatus | undefined
): status is ImageConvertStatus.SUCCESS {
  return status === ImageConvertStatus.SUCCESS;
}

export function isTerminalImageConvertStatus(
  status: ImageConvertStatus | undefined
): boolean {
  return (
    status === ImageConvertStatus.INCORRECT_PAGES ||
    status === ImageConvertStatus.UNCONVERTABLE_EXTENSION ||
    status === ImageConvertStatus.FAILED ||
    status === ImageConvertStatus.SUCCESS
  );
}

/**
 * Merge imageConvertStatus on document upsert.
 * - Terminal statuses always win.
 * - Issue list sync often sends stale PENDING; do not store it over unknown status.
 */
export function mergeImageConvertStatus(
  nextStatus: ImageConvertStatus | undefined,
  previousStatus: ImageConvertStatus | undefined
): ImageConvertStatus | undefined {
  if (isTerminalImageConvertStatus(nextStatus)) {
    return nextStatus;
  }

  if (isTerminalImageConvertStatus(previousStatus)) {
    return previousStatus;
  }

  if (
    nextStatus === ImageConvertStatus.PENDING &&
    previousStatus === undefined
  ) {
    return undefined;
  }

  if (nextStatus === undefined) {
    if (previousStatus === ImageConvertStatus.PENDING) {
      return undefined;
    }
    return previousStatus;
  }

  return nextStatus;
}

export type ImageConvertStatusNegative =
  | ImageConvertStatus.PENDING
  | ImageConvertStatus.INCORRECT_PAGES
  | ImageConvertStatus.FAILED
  | ImageConvertStatus.UNCONVERTABLE_EXTENSION;
